"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reactBaseStyles;

var _classes = _interopRequireDefault(require("../classes"));

function reactBaseStyles() {
  return {
    className: _classes.default.apply(void 0, arguments)
  };
}